import React from "react";

import { Form } from "react-final-form";

import { useAuthProvider,useAuthenticated } from "react-admin";

import AppBar from "../../../Components/header/index";
import MentorProfile from "../../MentorProfile/Components/mentorProfile"
import ScheduleForm1 from "../Components/scheduleForm1"
import AppProvider from "../../../Components/bootstrap"

import { useAppointment } from "../hooks"

import moment from 'moment'


const ScheduleAppointment1 = props => {
  useAuthProvider();
  useAuthenticated()
  const { selectTimeSlot } = useAppointment()
  return (
    <div style={{ zoom: "88%" }}>
      <AppProvider>
        <AppBar />
        <MentorProfile typography="Home / Mentor Profile / Schedule Appointment" />
        <div style={{ paddingLeft: "4%", paddingRight: "4%" }}>
          <Form
            initialValues={{
              selectedSlots:[],
              date: moment().startOf('day').add('1','day')
            }}
            onSubmit={async response => {
              selectTimeSlot(response.selectedSlots)
            }}
            keepDirtyOnReinitialize
            render={ScheduleForm1}
          />
        </div>
      </AppProvider>
    </div>
  );
};
export default ScheduleAppointment1;